import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const TomatoCharacter = (props) => {
    const primaryColor = "#d32f2f"; // Tomato red
    const secondaryColor = "#b71c1c"; // Darker red for details

    const renderTomatoBody = () => (
        <>
            {/* Tomato Body - slightly squashed sphere */}
            <mesh castShadow position={[0, 0, 0]}>
                <sphereGeometry args={[0.3, 16, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Tomato stem */}
            <group position={[0, 0.28, 0]}>
                {/* Main stem */}
                <mesh castShadow>
                    <cylinderGeometry args={[0.03, 0.03, 0.1, 8]} />
                    <meshStandardMaterial color="#388e3c" />
                </mesh>

                {/* Leaf one */}
                <mesh castShadow position={[0.06, 0, 0.06]} rotation={[0, Math.PI/4, 0]}>
                    <boxGeometry args={[0.1, 0.02, 0.05]} />
                    <meshStandardMaterial color="#4caf50" />
                </mesh>

                {/* Leaf two */}
                <mesh castShadow position={[-0.06, 0, 0.06]} rotation={[0, -Math.PI/4, 0]}>
                    <boxGeometry args={[0.1, 0.02, 0.05]} />
                    <meshStandardMaterial color="#4caf50" />
                </mesh>
            </group>

            {/* Slight indentation at top */}
            <mesh castShadow position={[0, 0.29, 0]}>
                <cylinderGeometry args={[0.05, 0.01, 0.02, 8]} />
                <meshStandardMaterial color={secondaryColor} />
            </mesh>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderTomatoBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default TomatoCharacter;
